
import React from 'react'

import createBlockTypeButton from './util/createBlockTypeButton';

export default createBlockTypeButton({
  blockType: 'blockquote',
  children: (
    <i className={"fa fa-quote-right"} aria-hidden="true"></i>
  ),
});
